import { OrganismeStatutEtapier } from '@common/services';

export const ORGANISME_STATUT_ETAPIER_TEXTS: Record<OrganismeStatutEtapier, string> = {
  [OrganismeStatutEtapier.ETAPE_1]: 'Etape 1',
  [OrganismeStatutEtapier.ETAPE_2]: 'Etape 2',
  [OrganismeStatutEtapier.ETAPE_3]: 'Etape 3',
  [OrganismeStatutEtapier.ETAPE_4]: 'Etape 4',
  [OrganismeStatutEtapier.TERMINER]: 'Terminé',
};
